export const EMPLOYMENT_LIST_FETCH = 'employer/EMPLOYMENT_LIST_FETCH';
export const EMPLOYMENT_LIST_SUCCESS = 'employer/EMPLOYMENT_LIST_SUCCESS';
